import { cn } from '@workspace/lib';
import { ApplicationItem } from './ApplicationItem';
import { pageApplicationsVariants } from '@workspace/blocks/PageApplications/applications.variants';
import type { ApplicationListProps } from '../application.types';
import { getApplicationItemCount } from '../layout';

export function ApplicationList({ items }: ApplicationListProps) {
  const itemCount = getApplicationItemCount(items.length);
  const { listContainer, list } = pageApplicationsVariants({ itemCount });

  return (
    <div className={cn('mx-auto w-full', listContainer())}>
      <div className={cn('grid w-full', list())}>
        {items?.map((item, key: number) => (
          <ApplicationItem key={item._key || key} item={item} itemCount={itemCount} />
        ))}
      </div>
    </div>
  );
}
